const ScheduleTitle = () => {
    return (
        <div className="field">
            <label htmlFor="icon">Розклад дзвінків : </label>
        </div>
    );
};

export default ScheduleTitle;
